<script>
export default {
    props: {
        contract: {
            type: Object,
            default: null,
        }
    }
}
</script>
<template>
    <div class="contract-breadcrumb">
        <div class="contract-breadcrumb__content">
            <router-link :to="{name: 'contractManagementOverview'}">
                {{ $t('contract.breadcrumb.label') }}
            </router-link>
            <span v-if="contract"><i class="fa fa-angle-right"/> </span>
            <span>{{ contract.supplierName }}</span>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractBreadcrumb/ContractBreadcrumb.vue